import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { client } from './redux/store';

const resources = {
  en: {
    translation: '',
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    client.get('/translations').then((res) => {
      for (const dataKey in res.data) {
        i18n.addResourceBundle(dataKey, 'translation', res.data[dataKey].translation);
      }
    });
  });

export default i18n;
